import { Button } from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { useTranslation } from '@web/src/lib/intl/react'
import { ArrowLeftIcon } from 'lucide-react'

interface SFBackPageHeaderProps {
  title: string
  lowerText: string | React.ReactNode
  hideBackButton?: boolean
  onBackClick: () => void
}

const SFBackPageHeader = ({ title, lowerText, onBackClick, hideBackButton = false }: SFBackPageHeaderProps) => {
  const { t } = useTranslation()

  return (
    <div className={cn('flex w-full items-center justify-start gap-2 pb-2')}>
      {!hideBackButton && (
        <Button
          aria-label={t('Go back')}
          className={cn('size-12 shrink-0')}
          onClick={onBackClick}
          size="icon"
          type="button"
          variant="default"
        >
          <ArrowLeftIcon className="size-5" />
        </Button>
      )}
      <div className="flex w-full flex-col items-start gap-0">
        <h1 className="font-semibold text-2xl text-foreground tracking-tight">{title}</h1>
        <div className="text-muted-foreground text-sm">{lowerText}</div>
      </div>
    </div>
  )
}

export default SFBackPageHeader
